import React from 'react';
import './LegalPages.css';

const TermsOfService = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-content">
          <h1>Terms of Service</h1>
          <p className="last-updated">Last updated: January 2025</p>
          
          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using the Vishwa Deva Homestay website and services, you accept and 
              agree to be bound by the terms and provision of this agreement. If you do not agree 
              to abide by the above, please do not use this service.
            </p>
          </section>

          <section>
            <h2>2. Description of Service</h2>
            <p>
              Vishwa Deva Homestay provides accommodation services, including but not limited to:
            </p>
            <ul>
              <li>Hotel room bookings and reservations</li>
              <li>Pickup and drop services from railway/bus stations</li>
              <li>Local and intercity taxi services</li>
              <li>Vegetarian food services</li>
              <li>Tourist information and assistance</li>
            </ul>
          </section>

          <section>
            <h2>3. Booking and Reservation Terms</h2>
            <h3>3.1 Reservation Process</h3>
            <ul>
              <li>All bookings must be confirmed in advance</li>
              <li>Valid identification documents are required at check-in</li>
              <li>Payment terms will be communicated at the time of booking</li>
              <li>Group bookings require advance notice and special arrangements</li>
            </ul>

            <h3>3.2 Check-in and Check-out</h3>
            <ul>
              <li>Standard check-in time: 12:00 PM onwards</li>
              <li>Standard check-out time: 11:00 AM</li>
              <li>Early check-in and late check-out subject to availability and additional charges</li>
              <li>Guests must present valid ID proof at check-in</li>
            </ul>

            <h3>3.3 Cancellation Policy</h3>
            <ul>
              <li>Cancellation 24 hours before check-in: Full charge</li>
              <li>Cancellation within 24 hours: Full charge</li>
              <li>No-show: 100% of booking amount</li>
              <li>In any of the above cases please note that we are holding your room reserved and loose the opportunity to secure reservation from other prospects in the time of cancellation hence we cannot process refunds in this case</li>
            </ul>
          </section>

          <section>
            <h2>4. Guest Responsibilities</h2>
            <p>Guests are responsible for:</p>
            <ul>
              <li>Providing accurate booking information</li>
              <li>Maintaining proper behavior and respecting other guests</li>
              <li>Following hotel rules and regulations</li>
              <li>Paying for any damages caused during their stay</li>
              <li>Complying with local laws and regulations</li>
              <li>Ensuring the safety of their personal belongings</li>
            </ul>
          </section>

          <section>
            <h2>5. Prohibited Activities</h2>
            <p>The following activities are strictly prohibited:</p>
            <ul>
              <li>Smoking in non-smoking areas</li>
              <li>Bringing pets without prior permission</li>
              <li>Engaging in illegal activities</li>
              <li>Disturbing other guests</li>
              <li>Damaging hotel property</li>
              <li>Unauthorized commercial activities</li>
              <li>Bringing non veg food or alcohol or other illegal substances</li>
              <li>Indulging in activities considered as illegal or harmful to the hotel or other guests or disobeying local and nearby community rules</li>
            </ul>
          </section>

          <section>
            <h2>6. Payment Terms</h2>
            <h3>6.1 Pricing</h3>
            <ul>
              <li>AC Room: ₹900 per night</li>
              <li>Non-AC Room: ₹650 per night</li>
              <li>Extra bed: ₹200 per night</li>
              <li>Group bookings: Special rates available</li>
              <li>All prices are subject to applicable taxes and GST and subject to changes according to the current demand and season</li>
            </ul>

            <h3>6.2 Payment Methods</h3>
            <ul>
              <li>Cash payment at check-in</li>
              <li>Bank transfers (advance booking)</li>
              <li>UPI payments accepted</li>
            </ul>
          </section>

          <section>
            <h2>7. Service Limitations</h2>
            <p>We strive to provide excellent service but cannot guarantee:</p>
            <ul>
              <li>Specific room numbers or views</li>
              <li>Availability of all amenities at all times</li>
              <li>Exact arrival times for pickup services</li>
              <li>Weather-dependent outdoor activities</li>
              <li>Uninterrupted internet connectivity</li>
            </ul>
          </section>

          <section>
            <h2>8. Privacy and Data Protection</h2>
            <p>
              Your privacy is important to us. Please review our Privacy Policy, which also 
              governs your use of the service, to understand our practices regarding the 
              collection and use of your personal information.
            </p>
          </section>

          <section>
            <h2>9. Intellectual Property</h2>
            <p>
              The content on this website, including text, graphics, images, and software, 
              is the property of Vishwa Deva Homestay and is protected by copyright laws. 
              You may not reproduce, distribute, or create derivative works without our 
              written permission.
            </p>
          </section>

          <section>
            <h2>10. Limitation of Liability</h2>
            <p>
              Vishwa Deva Homestay shall not be liable for any indirect, incidental, special, 
              consequential, or punitive damages, including but not limited to loss of profits, 
              data, use, goodwill, or other intangible losses resulting from your use of our services.
            </p>
          </section>

          <section>
            <h2>11. Indemnification</h2>
            <p>
              You agree to indemnify and hold harmless Vishwa Deva Homestay from any claims, 
              damages, losses, or expenses arising from your use of our services or violation 
              of these terms.
            </p>
          </section>

          <section>
            <h2>12. Governing Law</h2>
            <p>
              These terms shall be governed by and construed in accordance with the laws of India. 
              Any disputes arising from these terms shall be subject to the exclusive jurisdiction 
              of the courts in Varanasi, Uttar Pradesh, India.
            </p>
          </section>

          <section>
            <h2>13. Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. Changes will be effective 
              immediately upon posting. Your continued use of our services constitutes acceptance 
              of the modified terms.
            </p>
          </section>

          <section>
            <h2>14. Contact Information</h2>
            <p>
              For questions about these Terms of Service, please contact us:
            </p>
            <div className="contact-info">
              <p><strong>Vishwa Deva Homestay</strong></p>
              <p>Phone: +919580110340, +919415600200</p>
              <p>Email: info@vishwadeva.com</p>
              <p>Address: D53/106 CHHOTI GAIBI, Rathyatra - Mahmoorganj Rd, opposite BCG SCHOOL FOR DEAF AND DUMB, Varanasi, Uttar Pradesh 221010</p>
  
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService; 